import { render, staticRenderFns } from "./PendingConfirmationOrders.vue?vue&type=template&id=02e5103c"
import script from "./PendingConfirmationOrders.vue?vue&type=script&lang=js"
export * from "./PendingConfirmationOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports